import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import {
  getCommissionSummary,
  getMyLedger,
  processWithdrawal,
  type CommissionLedgerParams,
} from '../../infrastructure/api/commissionsApi';
import { qKeys } from './keys';
import { queryDefaults } from './queryPolicy';

/** E09 — GET /commissions/my-ledger (paged + month/type/tier filters). */
export function useCommissionLedger(params: CommissionLedgerParams) {
  return useQuery({
    queryKey: qKeys.commissions.ledger(params),
    queryFn: () => getMyLedger(params),
    ...queryDefaults,
    placeholderData: (prev) => prev, // keep the previous page while the next loads
  });
}

/** E10 — GET /commissions/summary */
export function useCommissionSummary() {
  return useQuery({ queryKey: qKeys.commissions.summary, queryFn: getCommissionSummary, ...queryDefaults });
}

/** POST /commissions/process-withdrawal — refreshes every wallet-related query on success. */
export function useProcessWithdrawal() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (idempotencyKey: string) => processWithdrawal(idempotencyKey),
    // onSettled: a 409 (balance changed under the call) must also refresh the figures.
    onSettled: () => {
      void queryClient.invalidateQueries({ queryKey: qKeys.dashboard });
      void queryClient.invalidateQueries({ queryKey: qKeys.commissions.all });
      void queryClient.invalidateQueries({ queryKey: qKeys.withdrawals.all });
    },
  });
}
